import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

const _get = async (queryParamFilters, queryParam, setParams, setMetadata, setUdfFields) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  setParams?.(params)

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/delivery-order',
    params: params,
  })

  setMetadata?.(response?.data.metadata)

  const paginated_result = response?.data?.data?.paginated_result

  setUdfFields?.(paginated_result?.[0]?.user_definition_fields || [])

  const modifiedPaginatedResult = paginated_result?.map((result) => {
    const customFields = result.user_definition_fields?.reduce(
      (prev, curr) => ({ ...prev, [curr.key]: curr }),
      {}
    )
    return { ...result, ...customFields }
  })

  return {
    ...response?.data,
    data: {
      ...response?.data.data,
      paginated_result: modifiedPaginatedResult,
    },
  }
}

export const get =
  (queryParamFilters, setParams, setMetadata, setUdfFields) => async (queryParam) =>
    await _get(queryParamFilters, queryParam, setParams, setMetadata, setUdfFields)

const _getDOAccurate = async (queryParamFilters, queryParam, setParams, setMetadata) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    ...queryParamFilters,
  }

  setParams?.(params)

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/delivery-order/external',
    params: params,
  })

  setMetadata?.(response?.data.metadata)

  return response?.data
}

export const getDOAccurate = (queryParamFilters, setParams, setMetadata) => async (queryParam) =>
  await _getDOAccurate(queryParamFilters, queryParam, setParams, setMetadata)

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/delivery-order/${id}`,
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/delivery-order',
    data,
  })

  return response?.data
}

export const bulkStore = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/delivery-order/bulk',
    data,
  })

  return response?.data
}

export const update = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `/delivery-order/${id}`,
    data,
  })

  return response?.data
}

export const deleteSingle = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: `/delivery-order/${id}`,
  })

  return response?.data
}

export const deleteMany = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/delivery-order/delete`,
    data,
  })

  return response?.data
}

export const duplicate = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/delivery-order/duplicate`,
    data,
  })

  return response?.data
}

export const storeExternal = async (data, providerCode) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/delivery-order/${providerCode}`,
    data,
  })

  return response?.data
}

export const validateGeocode = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/delivery-order/external/validate-geocode`,
    data,
  })

  return response?.data
}

export const syncBulk = async () => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/delivery-order/accurate/sync-bulk`,
  })

  return response?.data
}

export const deleteInvoice = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: `/delivery-order/${id}/remove-invoice`,
  })

  return response?.data
}

export const track = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/delivery-order/track/${id}`,
  })

  return response?.data
}

export const getLineOrder = async (queryParam = {}) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters?.length > 0 ? queryParam.filters : undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/line-order',
    params,
  })

  return response?.data
}

export const integrationShell = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/delivery-order/${id}/shell`,
    data,
  })

  return response?.data
}

const _getDoTrackSensor = async (
  uuid,
  queryParamFilters,
  queryParam,
  setParams,
  setMetadata,
  setUdfFields
) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  setParams?.(params)

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/delivery-order/track/${uuid}/sensor`,
    params: params,
  })

  setMetadata?.(response?.data.metadata)

  const paginated_result = response?.data?.data?.paginated_result

  setUdfFields?.(paginated_result?.[0]?.user_definition_fields || [])

  const modifiedPaginatedResult = paginated_result?.map((result) => {
    const customFields = result.user_definition_fields?.reduce(
      (prev, curr) => ({ ...prev, [curr.key]: curr }),
      {}
    )
    return { ...result, ...customFields }
  })

  return {
    ...response?.data,
    data: {
      ...response?.data.data,
      paginated_result: modifiedPaginatedResult,
    },
  }
}

export const getDoTrackSensor =
  (uuid, queryParamFilters, setParams, setMetadata, setUdfFields) => async (queryParam) =>
    await _getDoTrackSensor(
      uuid,
      queryParamFilters,
      queryParam,
      setParams,
      setMetadata,
      setUdfFields
    )

export const getDoorActivity = async (id, doorCode) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/delivery-order/track/${id}/door-activity/${doorCode}`,
  })

  return response?.data
}

export const validateDo = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/delivery-order/validate',
    data,
  })

  return response?.data
}

export const BulkValidateDo = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/delivery-order/validate-candidate',
    data,
  })

  return response?.data
}
